import {Transition, TransitionChild} from "@headlessui/react";
import {t} from "i18next";
import React, {useEffect} from "react";
import {useAuth} from "../hooks/useAuth";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

export const EventTicketModal = (props) => {
    const {
        selectedEventDetails,
        ticketDetails,
        setTicketDetails,
        showEventTicketModal,
        setShowEventTicketModal
    } = props;

    const {account, isAuthenticated} = useAuth();
    const navigate = useNavigate();

    const modeOfAttendingDetails = (selectedModeOfAttending) => {
        switch (selectedModeOfAttending) {
            case "VIRTUAL":
                return {
                    label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.VIRTUAL.LABEL"),
                    info: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.VIRTUAL.MESSAGE"),
                    icon: "/assets/zoom-company-icon.svg"
                }
            case "PHYSICAL" && selectedEventDetails.isTicketed:
                return {
                    label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.PHYSICAL.LABEL"),
                    info: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.PHYSICAL.MESSAGE"),
                    icon: "/assets/location-icon-filled.svg"
                }
            default:
                return {
                    label: t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.DEFAULT"),
                }
        }
    }

    const handleRegisterForYellowPageButtonClick = () => {
        console.log("(EventRegistrationForm) Inside Handle Register on Yellow Page Button Click!");
        toast.dismiss();

        if (!isAuthenticated) {
            toast.warning(t("EVENTS_PAGE.REGISTER_AS_MEMBER_TO_CONTINUE"));
            setTimeout(() => {
                navigate("/register");
            }, 500);
        } else {
            const fullName = account.firstName + (account.middleName ? ' ' + account.middleName : '') + (account.lastName ? ' ' + account.lastName : '');
            const prefillUrl = `https://docs.google.com/forms/d/e/1FAIpQLSfdISSvtAnv7-spT7mS_PfQHIFu6bE-TWg52f8ygSsX89-24g/viewform?usp=pp_url` +
                `&entry.13364315=${account._id}` +
                `&entry.831547290=${encodeURIComponent(fullName)}` +
                `&entry.1457500551=${encodeURIComponent(account.familyTreeName)}`;

            window.open(prefillUrl, '_blank');
        }
    }

    const handleClose = () => {
        console.log("(EventRegistrationForm) Inside Handle Close!");

        setShowEventTicketModal(false);
        setTimeout(() => {
            setTicketDetails({
                _id: '',
                userId: '',
                eventId: '',
                numberOfSeats: '',
                qrCodeBase64: '',
                rowNumber: '',
                modeOfAttending: '',
            });
        }, 200);
    }

    useEffect(() => {
        console.log("(EventTicketModal) Selected Event Details: ", selectedEventDetails);
    }, []);

    return (
        <>
            {document.body.classList.toggle("overflow-y-hidden", showEventTicketModal)}

            <Transition show={showEventTicketModal}>
                <div
                    className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh] 
                        min-w-[100dvw] w-[100dvw] max-w-[100dvw]
                        flex items-center justify-center 
                        fixed inset-0 z-[100]
                        bg-black/75 backdrop-blur-sm
                        data-[closed]:opacity-0
                        data-[enter]:duration-150 data-[enter]:data-[closed]:ease-out
                        data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
                >
                    <TransitionChild
                        enter="transition-transform duration-300 ease-out"
                        enterFrom="translate-y-full"
                        enterTo="translate-y-0"
                        leave="transition-transform duration-300 ease-in"
                        leaveFrom="translate-y-0"
                        leaveTo="translate-y-full"
                    >
                        <div
                            className="min-h-fit h-fit max-h-[100dvh]
                                landscape:min-w-[25vw] landscape:max-w-[90vw]

                                portrait:min-h-full portrait:h-full portrait:max-h-full
                                portrait:md:!min-h-fit portrait:md:!h-fit portrait:md:!max-h-fit

                                portrait:min-w-[100dvw] portrait:w-[100dvw] portrait:max-w-[100dvw]
                                portrait:md:min-w-[40vw] portrait:md:max-w-[90vw]

                                transform z-50 rounded-xl flex items-center justify-center
                                data-[enter]:duration-150 data-[enter]:data-[closed]:scale-75
                                data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95"
                        >
                            <div
                                className="form-modal-container h-[90vh] max-h-[90vh]
                                    portrait:md:!h-[90vh] portrait:md:!max-h-[90vh]
                                    landscape:!min-w-[30vw] landscape:!w-[30vw] landscape:!max-w-fit
                                    portrait:!min-w-full portrait:!w-full portrait:!max-w-full
                                    portrait:md:!min-w-[60dvw] portrait:md:!w-[60dvw] portrait:md:!max-w-[60dvw]"
                            >
                                {/* Header */}
                                <div className={"form-modal-header-container"}>
                                    {/* Header Title | Close Button */}
                                    <div className={"flex flex-row items-center justify-between"}>
                                        {/* Form Title */}
                                        <h2>
                                            {
                                                selectedEventDetails.requiresRegistration
                                                    ? t("EVENTS_PAGE.TICKET_MODAL.TITLE.REGISTRATION_BASED")
                                                    : t("EVENTS_PAGE.TICKET_MODAL.TITLE.TICKET_BASED")
                                            }
                                        </h2>

                                        {/* Close Button */}
                                        <button onClick={handleClose}>
                                            <img
                                                className={"w-[75%] h-[75%]"}
                                                src={"/assets/close-icon.png"}
                                                alt={"Close"}
                                                title={"Close"}
                                            />
                                        </button>
                                    </div>

                                    {/* Divider */}
                                    <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                                </div>

                                {/* Ticket Details */}
                                <div
                                    className={`relative form-modal-body-container
                                        !flex-1 !max-h-none !bg-transparent`}
                                >
                                    {/* Ticket QR Code */}
                                    {
                                        ticketDetails.modeOfAttending === 'PHYSICAL' ? (
                                            <div
                                                className={`flex-1 w-full flex items-center justify-center rounded-xl`}
                                            >
                                                <img
                                                    src={ticketDetails.qrCodeBase64}
                                                    alt={"Ticket QR Code"}
                                                    className="w-full aspect-auto"
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                className={`h-fit p-[1vh] w-full flex items-center justify-center 
                                                    bg-gray-100 rounded-xl border-2 border-[#EAEAEA]`}
                                            >
                                                <p
                                                    className="flex-1 text-gray-900 font-custom-semi-bold
                                                        portrait:text-[1rem] portrait:md:text-[1.15rem]
                                                        portrait:jk:text-[1.3rem] portrait:lg:text-[1.5rem]
                                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                        landscape:lg:text-[1rem] leading-tight text-center"
                                                >
                                                    {t("EVENTS_PAGE.TICKET_MODAL.VIRTUAL_MODE_MESSAGE")}
                                                </p>
                                            </div>
                                        )
                                    }

                                    {/* Ticket Bearer Details */}
                                    <div
                                        className={`w-full flex-1 flex flex-col items-center
                                            gap-1 portrait:gap-2 portrait:md:gap-1 pb-[calc(1vh+0.25rem)]
                                            relative after:content-[''] after:absolute
                                            after:right-0 after:bottom-0 after:left-0
                                            after:h-[1.5px] after:bg-[length:10px_1px]
                                            after:bg-[linear-gradient(90deg,#EEEEE2,#EEEEE2_50%,transparent_0,transparent)]`}
                                    >
                                        {/* Full Name */}
                                        <div
                                            className={`w-full flex portrait:flex-col
                                                portrait:md:flex items-center gap-4
                                                portrait:gap-1 portrait:md:gap-4`}
                                        >
                                            <p
                                                className="w-[37.5%]  portrait:w-full text-[#9B9B9B] font-custom-medium
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {t("EVENTS_PAGE.TICKET_MODAL.NAME")}
                                            </p>
                                            <p
                                                className="flex-1 portrait:w-full portrait:md:flex-1
                                                    text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {account.firstName + ' ' + account.middleName}
                                            </p>
                                        </div>

                                        {/* Email */}
                                        <div
                                            className={`w-full flex portrait:flex-col
                                                portrait:md:flex items-center gap-4
                                                portrait:gap-1 portrait:md:gap-4`}
                                        >
                                            <p
                                                className="w-[37.5%]  portrait:w-full text-[#9B9B9B] font-custom-medium
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {t("EVENTS_PAGE.TICKET_MODAL.EMAIL")}
                                            </p>
                                            <p
                                                className="flex-1 portrait:w-full portrait:md:flex-1
                                                    text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {account.email}
                                            </p>
                                        </div>

                                        {/* WhatsApp Number */}
                                        <div
                                            className={`w-full flex portrait:flex-col
                                                portrait:md:flex items-center gap-4
                                                portrait:gap-1 portrait:md:gap-4`}
                                        >
                                            <p
                                                className="w-[37.5%]  portrait:w-full text-[#9B9B9B] font-custom-medium
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {t("EVENTS_PAGE.TICKET_MODAL.WHATSAPP_NUMBER")}
                                            </p>
                                            <p
                                                className="flex-1 portrait:w-full portrait:md:flex-1
                                                    text-gray-900 font-custom-semi-bold
                                                    portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                    landscape:lg:text-[1rem] leading-tight"
                                            >
                                                {account.phone.dialingCode + ' ' + account.phone.number}
                                            </p>
                                        </div>

                                        {/* Mode of Attending */}
                                        {
                                            selectedEventDetails.isVirtualModeEnabled && (
                                                <div
                                                    className={`w-full flex portrait:flex-col 
                                                        portrait:md:flex items-center gap-4
                                                        portrait:gap-1 portrait:md:gap-4`}
                                                >
                                                    <p
                                                        className={`w-[37.5%] portrait:w-full portrait:md:w-[37.5%]
                                                            text-[#9B9B9B] font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight`}
                                                    >
                                                        {t("EVENTS_PAGE.REGISTRATION_FORM.BOOKING_DETAILS.MODE_OF_ATTENDING.LABEL")}
                                                    </p>

                                                    <p
                                                        className="flex-1 portrait:w-full portrait:md:flex-1
                                                            text-gray-900 font-custom-semi-bold
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
                                                    >
                                                        {modeOfAttendingDetails(ticketDetails.modeOfAttending).label}
                                                    </p>
                                                </div>
                                            )
                                        }

                                        {/* Number of Seats */}
                                        {
                                            ticketDetails.modeOfAttending === 'PHYSICAL' && selectedEventDetails.isTicketed && (
                                                <div
                                                    className={`w-full flex portrait:flex-col
                                                        portrait:md:flex items-center gap-4
                                                        portrait:gap-1 portrait:md:gap-4`}
                                                >
                                                    <p
                                                        className="w-[37.5%]  portrait:w-full text-[#9B9B9B] font-custom-medium
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
                                                    >
                                                        {t("EVENTS_PAGE.TICKET_MODAL.NUMBER_OF_SEATS")}
                                                    </p>
                                                    <p
                                                        className="flex-1 portrait:w-full portrait:md:flex-1
                                                            text-gray-900 font-custom-semi-bold
                                                            portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                            portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                            landscape:text-[0.8rem] landscape:jk:text-[0.9rem]
                                                            landscape:lg:text-[1rem] leading-tight"
                                                    >
                                                        {ticketDetails.numberOfSeats} {ticketDetails.rowNumber && ticketDetails.rowNumber !== "" && `(${ticketDetails.rowNumber})`}
                                                    </p>
                                                </div>
                                            )
                                        }

                                        {/*/!* Food Consent *!/*/}
                                        {/*{*/}
                                        {/*    ticketDetails.modeOfAttending === 'PHYSICAL' && (*/}
                                        {/*        <div*/}
                                        {/*            className={`w-full flex portrait:flex-col*/}
                                        {/*                portrait:md:flex items-center gap-4*/}
                                        {/*                portrait:gap-1 portrait:md:gap-4`}*/}
                                        {/*        >*/}
                                        {/*            <p*/}
                                        {/*                className="w-[37.5%]  portrait:w-full text-[#9B9B9B] font-custom-medium*/}
                                        {/*                    portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
                                        {/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
                                        {/*                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]*/}
                                        {/*                    landscape:lg:text-[1rem] leading-tight"*/}
                                        {/*            >*/}
                                        {/*                {t("EVENTS_PAGE.TICKET_MODAL.FOOD_CONSENT.LABEL")}*/}
                                        {/*            </p>*/}
                                        {/*            <p*/}
                                        {/*                className="flex-1 portrait:w-full portrait:md:flex-1*/}
                                        {/*                    text-gray-900 font-custom-semi-bold*/}
                                        {/*                    portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
                                        {/*                    portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
                                        {/*                    landscape:text-[0.8rem] landscape:jk:text-[0.9rem]*/}
                                        {/*                    landscape:lg:text-[1rem] leading-tight"*/}
                                        {/*            >*/}
                                        {/*                {*/}
                                        {/*                    ticketDetails.foodConsent*/}
                                        {/*                        ? t("EVENTS_PAGE.TICKET_MODAL.FOOD_CONSENT.OPTIONS.YES")*/}
                                        {/*                        : t("EVENTS_PAGE.TICKET_MODAL.FOOD_CONSENT.OPTIONS.NO")*/}
                                        {/*                }*/}
                                        {/*            </p>*/}
                                        {/*        </div>*/}
                                        {/*    )*/}
                                        {/*}*/}
                                    </div>

                                    {/* Information */}
                                    {/*{*/}
                                    {/*    selectedEventDetails.requiresRegistration && (*/}
                                    {/*        <p*/}
                                    {/*            className="flex-1 text-gray-900 font-custom-semi-bold*/}
                                    {/*                portrait:text-[1.25rem] portrait:md:text-[1rem]*/}
                                    {/*                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]*/}
                                    {/*                landscape:text-[0.8rem] landscape:jk:text-[0.9rem]*/}
                                    {/*                landscape:lg:text-[1rem] leading-tight text-center"*/}
                                    {/*        >*/}
                                    {/*            {t("EVENTS_PAGE.TICKET_MODAL.YELLOW_PAGE_MESSAGE")}*/}
                                    {/*        </p>*/}
                                    {/*    )*/}
                                    {/*}*/}

                                    {/* Register on Yellow Page */}
                                    <div className={`flex justify-center items-center w-full`}>
                                        <button
                                            className={`landscape:w-fit portrait:w-full justify-center
                                                    flex items-center gap-2 bg-[#D26A53]
                                                    portrait:px-[0.95rem] portrait:py-[0.5rem]
                                                    portrait:md:px-[0.75rem] portrait:md:py-[0.45rem]
                                                    portrait:jk:px-[0.85rem] portrait:jk:py-[0.55rem]
                                                    portrait:lg:px-[1rem] portrait:lg:py-[0.75rem]

                                                    landscape:px-[0.75rem] landscape:py-[0.35rem]
                                                    landscape:jk:px-[0.85rem] landscape:jk:py-[0.4rem]
                                                    landscape:lg:px-[1rem] landscape:lg:py-[0.5rem]

                                                    rounded-lg shadow-lg  shadow-black/5
                                                    hover:ring-4 hover:ring-orange-300 hover:ring-offset-1
                                                    transition duration-300 ease-out`}
                                            onClick={handleRegisterForYellowPageButtonClick}
                                        >
                                            <p
                                                className={`font-custom-medium text-white leading-tight
                                                        line-clamp-1 overflow-x-scroll no-scrollbar
                                                        portrait:text-[1rem] portrait:md:text-[1.25rem] 
                                                        portrait:jk:text-[1.15rem] landscape:text-[0.8rem]
                                                        landscape:md:text-[0.85rem] landscape:jk:text-[1rem]`}
                                            >
                                                {t("EVENTS_PAGE.TICKET_MODAL.REGISTER_FOR_YELLOW_PAGE")}
                                            </p>

                                            <div
                                                className="flex items-center justify-center aspect-square
                                                    portrait:h-[1.25rem] portrait:md:h-[0.95rem] portrait:jk:h-[0.9rem]
                                                    landscape:h-[0.65rem] landscape:md:h-[0.75rem] landscape:jk:h-[1rem]"
                                            >
                                                <img
                                                    src={"/assets/redirect-icon.svg"}
                                                    className={"h-full aspect-square"}
                                                    alt={"Zoom"}
                                                />
                                            </div>
                                        </button>
                                    </div>

                                    {/* Agenda */}
                                    <div className={`w-full flex items-center justify-center rounded-xl`}>
                                        <img
                                            src={"/assets/joglekarkul-27th-sept-agenda.png"}
                                            alt={"Agenda"}
                                            className="w-full aspect-auto"
                                        />
                                    </div>


                                    {/* Note */}
                                    {
                                        ticketDetails.modeOfAttending === 'PHYSICAL' && (
                                            <p
                                                className="flex-1 text-[#6D6D6D] font-custom-medium-italic
                                                    portrait:text-[1rem] portrait:md:text-[0.8rem]
                                                    portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                                    landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                                    landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]
                                                    leading-tight text-center"
                                            >
                                                {t("EVENTS_PAGE.BOOKING_NOTE.LABEL")} {t("EVENTS_PAGE.BOOKING_NOTE.MESSAGE")}
                                            </p>
                                        )
                                    }
                                    {/*</div>*/}

                                    {/* Ticket Background SVG with Blur */}
                                    {/*<div*/}
                                    {/*    className={``}*/}
                                    {/*>*/}
                                    {/*    <svg className={`w-full aspect-auto`} viewBox="0 0 1472 2000" fill="none"*/}
                                    {/*         xmlns="http://www.w3.org/2000/svg">*/}
                                    {/*        <defs>*/}
                                    {/*            <filter id="shape-shadow-tailwind" x="-50%" y="-50%" width="200%"*/}
                                    {/*                    height="200%" filterUnits="objectBoundingBox">*/}
                                    {/*                <feDropShadow dx="0" dy="20" stdDeviation="15" floodColor="#f97316"*/}
                                    {/*                              floodOpacity="0.4"/>*/}
                                    {/*            </filter>*/}
                                    {/*        </defs>*/}
                                    {/*        <path*/}
                                    {/*            d="M79 1468L79 532C79 344.516 100.396 233.103 159.164 167.619C217.404 102.723 316.133 79 484 79H587.899C601.029 79 613.516 90.1496 616.673 106.665C626.382 157.472 653.776 186.884 685.529 202.99C716.448 218.673 750.495 221.272 773.905 221.272C797.316 221.272 831.362 218.673 862.281 202.99C894.035 186.884 921.428 157.472 931.138 106.665C934.308 90.0741 946.85 79.1566 959.648 79.4727C1112.81 83.2544 1219.85 110.262 1289.09 177.189C1358.16 243.943 1393 353.761 1393 532V1468C1393 1655.48 1371.6 1766.9 1312.84 1832.38C1254.6 1897.28 1155.87 1921 988 1921H959.911C947.015 1921 934.637 1910.18 930.943 1893.92L930.774 1893.14C920.145 1842 890.454 1812.83 858.291 1796.94C826.81 1781.4 793.425 1778.73 773.905 1778.73C754.385 1778.73 721 1781.4 689.52 1796.94C657.608 1812.7 628.13 1841.54 617.289 1891.94L617.036 1893.14C613.566 1909.83 601.001 1921 587.899 1921H484C316.133 1921 217.404 1897.28 159.164 1832.38C100.396 1766.9 79 1655.48 79 1468Z"*/}
                                    {/*            fill="white" stroke="#292D32" strokeWidth="30" strokeLinecap="round"*/}
                                    {/*            strokeLinejoin="round"*/}
                                    {/*            style={{filter: 'url(#shape-shadow-tailwind)'}}*/}
                                    {/*        />*/}
                                    {/*    </svg>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </Transition>
        </>
    )
}
